import {Component, OnInit} from '@angular/core';
import {NavService} from './nav.service';

@Component({
    selector: 'ac-nav-auto',
    templateUrl: './ac-nav-auto.component.html',
    styleUrls: ['./ac-nav-auto.component.less']
})
export class AcNavAutoComponent {


    constructor(public navService: NavService) {
    }

    getChildren(route: any) {
        return route?.routeConfig.children || route?.routeConfig._loadedConfig?.routes[0].children;
    }
}
